var _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2, _rect6, _rect7, _path3, _rect8, _rect9, _path4, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup307(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 320,
    viewBox: "0 0 460 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 320,
    rx: 8,
    fill: "#0B2878"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 240,
    width: 380,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 248,
    width: 80,
    height: 24,
    rx: 8,
    fill: "#0B2878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380 240H412C416.418 240 420 243.582 420 248V272C420 276.418 416.418 280 412 280H380V240Z",
    fill: "#3D4863"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 84,
    width: 380,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 92,
    width: 80,
    height: 24,
    rx: 8,
    fill: "#0B2878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380 84H412C416.418 84 420 87.5817 420 92V116C420 120.418 416.418 124 412 124H380V84Z",
    fill: "#3D4863"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 136,
    width: 380,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 144,
    width: 80,
    height: 24,
    rx: 8,
    fill: "#0B2878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380 136H412C416.418 136 420 139.582 420 144V168C420 172.418 416.418 176 412 176H380V136Z",
    fill: "#3D4863"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 188,
    width: 380,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 196,
    width: 80,
    height: 24,
    rx: 8,
    fill: "#0B2878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380 188H412C416.418 188 420 191.582 420 196V220C420 224.418 416.418 228 412 228H380V188Z",
    fill: "#3D4863"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 380,
    height: 32,
    rx: 8,
    fill: "#A3ACC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup307);
export default __webpack_public_path__ + "static/media/Group307.c678a9622fc3b8dea606c4b3ab77b02a.svg";
export { ForwardRef as ReactComponent };